import React from 'react';
import { Form, Button, Row, Col, Select } from 'antd';

const { Option } = Select;

const FormFilter = ({ form: { getFieldDecorator, validateFields, resetFields }, onSearch, loadingCategory, loadingIndustry, loadingcampaign, campaigns, industries, categories }) => {
  const itemLayout = {
    md: 8,
    sm: 12,
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  };
  const handleSearch = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        onSearch(values);
      }
    });
  };
  const handleReset = (e) => {
    e.preventDefault();
    resetFields();
    onSearch();
  };
  return (
    <Form onSubmit={handleSearch}>
      <Row gutter={32}>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Campaign">
            {getFieldDecorator('campaign', {
              initialValue: [],
            })(<Select loading={loadingcampaign} optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
            } placeholder='Chọn campaign'>
              {campaigns.map((campaign, key) => <Option key={`campaign_${key}`} value={campaign.campaign}>{campaign.campaign}</Option>)}
            </Select>)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Industry">
            {getFieldDecorator('industry', {
              initialValue: [],
            })(<Select loading={loadingIndustry} optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
            } placeholder='Chọn Industry'>
              {industries.map((industry, key) => <Option key={`industry_${key}`} value={industry.name}>{industry.name}</Option>)}
            </Select>)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Category">
            {getFieldDecorator('category', {
              initialValue: [],
            })(<Select loading={loadingCategory} optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
            }  placeholder='Chọn Category'>
              {categories.map((category, key) => <Option key={`category_${key}`} value={category.name}>{category.name}</Option>)}
          </Select>)}
          </Form.Item>
        </Col>
      </Row>
      <Row className='filter-segment'>
        <Col span={24}>
          <Button onClick={handleSearch} icon='search' type='primary'>Tìm kiếm</Button>
          {' '}
          <Button onClick={handleReset} icon='reload'>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};
export default Form.create({ name: 'form_filter_campaign' })(FormFilter);
